import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { isNonEmptyArray } from '../../../base/common/arrays.js';
import { DisposableStore } from '../../../base/common/lifecycle.js';
import { CharacterSet } from '../../common/core/characterClassifier.js';
export var CommitCharacterController = /*#__PURE__*/function () {
  function CommitCharacterController(editor, widget, accept) {
    var _this = this;

    _classCallCheck(this, CommitCharacterController);

    this._disposables = new DisposableStore();

    this._disposables.add(widget.onDidShow(function () {
      return _this._onItem(widget.getFocusedItem());
    }));

    this._disposables.add(widget.onDidFocus(this._onItem, this));

    this._disposables.add(widget.onDidHide(this.reset, this));

    this._disposables.add(editor.onWillType(function (text) {
      if (_this._active && !widget.isFrozen()) {
        var ch = text.charCodeAt(text.length - 1);

        if (_this._active.acceptCharacters.has(ch) && editor.getOption(0
        /* acceptSuggestionOnCommitCharacter */
        )) {
          accept(_this._active.item);
        }
      }
    }));
  }

  _createClass(CommitCharacterController, [{
    key: "_onItem",
    value: function _onItem(selected) {
      if (!selected || !isNonEmptyArray(selected.item.completion.commitCharacters)) {
        // no item or no commit characters
        this.reset();
        return;
      }

      if (this._active && this._active.item.item === selected.item) {
        // still the same item
        return;
      } // keep item and its commit characters


      var acceptCharacters = new CharacterSet();

      var _iterator = _createForOfIteratorHelper(selected.item.completion.commitCharacters),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var ch = _step.value;

          if (ch.length > 0) {
            acceptCharacters.add(ch.charCodeAt(0));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._active = {
        acceptCharacters: acceptCharacters,
        item: selected
      };
    }
  }, {
    key: "reset",
    value: function reset() {
      this._active = undefined;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._disposables.dispose();
    }
  }]);

  return CommitCharacterController;
}();